var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/form-actions/form-actions.tsx";
import React from 'react';
/** Container element to house form actions. */

const FormActions = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end space-x-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 3
    }
  }, children);
};

export default FormActions;